module.exports = __webpack_public_path__ + "img/98.13370d39.jpg";